import { useQuery } from "@tanstack/react-query";
import { ChevronRight } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

import * as api from "@/api/returns";

export function ProcessingListPage(): React.ReactElement {
  const { data: sessions = [], isLoading } = useQuery({
    queryKey: ["returns", "sessions"],
    queryFn: api.listSessions,
  });

  // Обрабатывать имеет смысл только закрытые сессии.
  const completed = sessions.filter((s) => s.status === "completed");

  return (
    <div className="mx-auto max-w-4xl space-y-4">
      <h1 className="text-2xl font-bold">Обработка возвратов</h1>
      <p className="text-sm text-muted-foreground">
        Выберите закрытую приёмку — мы найдём остатки на комиссии,
        предложим распределение по приходным накладным «Возврат от комиссионера»
        и создадим их в 1С.
      </p>

      {isLoading && <p className="text-sm text-muted-foreground">Загрузка…</p>}
      {!isLoading && completed.length === 0 && (
        <p className="text-sm text-muted-foreground">
          Нет закрытых приёмок для обработки.
        </p>
      )}

      <div className="space-y-2">
        {completed.map((s) => (
          <Link
            key={s.id}
            to={`/returns-processing/sessions/${s.id}`}
            className="flex items-center justify-between rounded-md border bg-card p-4 hover:bg-accent/40"
          >
            <div className="min-w-0">
              <div className="font-medium">
                {s.display_number ? `#${s.display_number} · ` : ""}
                {api.marketplaceTitle(s.marketplace)}
              </div>
              <div className="text-xs text-muted-foreground">
                {s.username} ·{" "}
                {s.completed_at
                  ? new Date(s.completed_at).toLocaleString("ru-RU")
                  : new Date(s.created_at).toLocaleString("ru-RU")}{" "}
                · {s.items_count} поз.
              </div>
            </div>
            <ChevronRight className="size-5 text-muted-foreground" />
          </Link>
        ))}
      </div>
    </div>
  );
}
